export const windowUnitChoices = [
  { label: "Time (Last N Days)", value: "DAYS" },
  { label: "Transactions (Last N Transactions)", value: "NUMBER_OF_TRANSACTIONS" },
];

export const featureCategoryChoices = [
  { label: "No category (default)", value: "" },
  { label: "App info", value: "app_info" },
  { label: "Device", value: "device" },
  { label: "Game metrics", value: "game_metrics" },
  { label: "Purchases", value: "purchases" },
];
